import axios from 'axios';
import store from './store';
export const api = axios.create({
  baseURL: 'https://interlinking.bbend.com/api'
});

// baseURL: 'http://localhost:4000'

api.interceptors.request.use((request) => {
  if (store.state.isLoggedIn) {
    request.headers.Authorization = 'Bearer ' + store.state.token;
  }
  return request;
});
